import React from "react";

import './aboutTeam.scss'

import Yael from "../../images/team/Yael Tamar.png";
import Sasha from "../../images/team/Sasha Abramovich.png";
import Alisha from "../../images/team/Alisha Outridge.jpg";
import Alex from "../../images/team/Aexey Hramchenko.png";
import Amit from "../../images/team/Amit Cherniak.png";
import Dasha from "../../images/team/Dasha Kolesnik.png";
import Jay from "../../images/team/Jay Hao.png";
import Judah from "../../images/team/Judah Finkelstein.png";
import Pavel from "../../images/team/Pavel Sviridov.png";
import Scott from "../../images/team/Scott Smith.png";
import Itai from "../../images/team/Itai David.png";
import Tatev from "../../images/team/Tatev Qalashyan .png";
import Vlad from "../../images/team/Vladyslav  Makarian.png";
import Yaroslav from "../../images/team/Yaroslav Reshetnyk.png";
import Zhanna from "../../images/team/Zhanna Manukian.png";
import aboutImg from "../../images/team/aboutImg.png";

function AboutTeam() {

  return (
    <div className="about-team">

      <div className="container">
        <div className="head">
          <img src={aboutImg} alt="real estate cryptocurrency coins" className="about-image" />
          <div className="about-container">
            <h1 className="title about">About TokenSuite by DIBS</h1>
            <div className="descr about about-sub" >
              DIBS is creating a vast multi-broker network to facilitate a market for the sale
              of secondary shares of private companies;
            </div>
            <div className="descr about">
              DIBS platform provides a complete digitization of the process with Web3 technology, allowing for fully transparent, secure and compliant transactions and seamless broker affiliation.
            </div>
          </div>
        </div>
        <h2 className="title">Executive Team</h2>
        <div className="descr" >
          Our comprehensive understanding of the development process and the <br />
          benefits of a digital marketplace is unmatched in the industry.
        </div>
        <div className="team-cards">
          <div className="team-item">
            <div className="team-img">
              <img src={Yael} alt="YAEL TAMAR" />
            </div>
            <div className="name">Yael Tamar</div>
            <div className="job">CEO &amp; Co-Founder</div>
          </div>
          <div className="team-item">
            <div className="team-img">
              <img src={Scott} alt="Scott" />
            </div>
            <div className="name">Scott Smith</div>
            <div className="job">Director of Investment Banking & Broker Dealer</div>
          </div>
          <div className="team-item">
            <div className="team-img">
              <img src={Alisha} alt="Alisha" />
            </div>
            <div className="name">Alisha Outridge</div>
            <div className="job">Cofounder & COO/CPO</div>
          </div>
          <div className="team-item">
            <div className="team-img">
              <img src={Amit} alt="Amit" />
            </div>
            <div className="name">Amit Cherniak</div>
            <div className="job">Founder & Board member</div>
          </div>
          <div className="team-item">
            <div className="team-img">
              <img src={Jay} alt="Jay" />
            </div>
            <div className="name">Jay Hao</div>
            <div className="job">Tech, Blockchain & Token Advisor</div>
          </div>
          <div className="team-item">
            <div className="team-img">
              <img src={Itai} alt="Sumit" />
            </div>
            <div className="name">Itai David</div>
            <div className="job">Cofounder & CTO</div>
          </div>
          <div className="team-item">
            <div className="team-img">
              <img src={Sasha} alt="Sasha" />
            </div>
            <div className="name">Sasha Abramovich</div>
            <div className="job">Head of Product</div>
          </div>
          <div className="team-item">
            <div className="team-img">
              <img src={Judah} alt="Judah" />
            </div>
            <div className="name">Judah Finkelstein</div>
            <div className="job">AI specialist</div>
          </div>
          <div className="team-item">
            <div className="team-img">
              <img src={Vlad} alt="Vlad" />
            </div>
            <div className="name">Vladyslav  Makarian</div>
            <div className="job">Blockchain Infrastructure & lead</div>
          </div>
          <div className="team-item">
            <div className="team-img">
              <img src={Pavel} alt="Pavel" />
            </div>
            <div className="name">Pavel Sviridov</div>
            <div className="job">Full Stack</div>
          </div>
          <div className="team-item">
            <div className="team-img">
              <img src={Tatev} alt="Tatev" />
            </div>
            <div className="name">Tatev Qalashyan</div>
            <div className="job">Front-end engineer & QA</div>
          </div>
          <div className="team-item">
            <div className="team-img">
              <img src={Yaroslav} alt="Yaroslav" />
            </div>
            <div className="name">Yaroslav Reshetnyk</div>
            <div className="job">Smart contracts</div>
          </div>
          <div className="team-item">
            <div className="team-img">
              <img src={Alex} alt="Alex" />
            </div>
            <div className="name">Alexey Hramchenko </div>
            <div className="job">Front-end engineer</div>
          </div>
          <div className="team-item">
            <div className="team-img">
              <img src={Dasha} alt="Dasha" />
            </div>
            <div className="name">Dasha Kolesnik</div>
            <div className="job">UX / Lead designer</div>
          </div>
          <div className="team-item">
            <div className="team-img">
              <img src={Zhanna} alt="Zhanna" />
            </div>
            <div className="name">Zhanna Manukian</div>
            <div className="job">UI</div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AboutTeam;
